import { useQuery } from "@tanstack/react-query";
import { fetchStudiesApi } from "@/API/fetchStudiesApi";
import { useLoadingContext } from "@/hooks/contextHooks/useLoadingContext";

export const useFetchStudies = (
  studySearchTerm: string,
  selectedProjectId: string | null,
) => {
  const { startLoading, stopLoading } = useLoadingContext();

  const query = useQuery({
    queryKey: ["studies", studySearchTerm, selectedProjectId],
    queryFn: async () => {
      startLoading();

      try {
        return await fetchStudiesApi(studySearchTerm, selectedProjectId);
      } finally {
        console.log("✅ Request completed.");
        stopLoading();
      }
    },
    retry: 1,
  });

  if (query.isFetching) {
    console.log("❌ Request overridden for studies.");
  }

  return query;
};
